import { render, staticRenderFns } from "./ConsumeHistoriesDialog.vue?vue&type=template&id=3ccb4bd3&scoped=true"
import script from "./ConsumeHistoriesDialog.vue?vue&type=script&lang=js"
export * from "./ConsumeHistoriesDialog.vue?vue&type=script&lang=js"
import style0 from "./ConsumeHistoriesDialog.vue?vue&type=style&index=0&id=3ccb4bd3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccb4bd3",
  null
  
)

export default component.exports